/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Image_Prefix_PlaceholderInputs */

const en_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const fr_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const de_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const it_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ru_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const es_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const zh_cn2_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const ja_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

const hi_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डीवीडी`)
};

const pt_pt2_image_export_image_prefix_placeholder = /** @type {(inputs: Image_Export_Image_Prefix_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVD`)
};

/**
* | output |
* | --- |
* | "DVD" |
*
* @param {Image_Export_Image_Prefix_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_image_prefix_placeholder = /** @type {((inputs?: Image_Export_Image_Prefix_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Image_Prefix_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_image_prefix_placeholder(inputs)
	if (locale === "de") return de_image_export_image_prefix_placeholder(inputs)
	if (locale === "it") return it_image_export_image_prefix_placeholder(inputs)
	if (locale === "ru") return ru_image_export_image_prefix_placeholder(inputs)
	if (locale === "es") return es_image_export_image_prefix_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_image_prefix_placeholder(inputs)
	if (locale === "ja") return ja_image_export_image_prefix_placeholder(inputs)
	if (locale === "hi") return hi_image_export_image_prefix_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_image_prefix_placeholder(inputs)
	return en_image_export_image_prefix_placeholder(inputs)
});